import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../store';
import type {
  CreateLabwareData,
  CreateTaskData,
  GraphEdges,
  TimeConstraintInstance,
} from '../../types';
import { cutNodeToClipboard } from '../actions';

export type CopiedData =
  | {
      dataType: 'task';
      data: CreateTaskData;
    }
  | {
      dataType: 'labware';
      data: CreateLabwareData;
    }
  | {
      dataType: 'multi';
      taskNodes: CreateTaskData[];
      labwareNodes: CreateLabwareData[];
      edges: GraphEdges;
      dataDependencyEdges: GraphEdges;
      timeConstraints: TimeConstraintInstance[];
    };

export type CutData =
  | {
      dataType: 'task';
      data: CreateTaskData;
      edges: GraphEdges;
      dataDependencyEdges: GraphEdges;
    }
  | {
      dataType: 'labware';
      data: CreateLabwareData;
      edges: GraphEdges;
    }
  | {
      dataType: 'multi';
      taskNodes: CreateTaskData[];
      labwareNodes: CreateLabwareData[];
      edges: GraphEdges;
      timeConstraints: TimeConstraintInstance[];
      dataDependencyEdges: GraphEdges;
    };

export interface CopyPasteState {
  copiedData: CopiedData | null;
}

const initialState: CopyPasteState = {
  copiedData: null,
};

export const copyPasteSlice = createSlice({
  name: 'copyPaste',
  initialState,
  reducers: {
    copyNodeToClipboard: (state, action: PayloadAction<CopiedData>) => {
      state.copiedData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(cutNodeToClipboard, (state, action) => {
      state.copiedData = action.payload;
    });
  },
});

export const { copyNodeToClipboard } = copyPasteSlice.actions;

export const selectCopiedData = (state: RootState): CopiedData | null =>
  state.copyPaste.copiedData;

export default copyPasteSlice.reducer;
